import classNames from 'classnames';
import React from 'react';

import styles from './PurposeMap.module.scss';

interface Circle {
  id: string;
  value: number;
  isHighLighted: boolean;
}

export interface PurposeMapSectionProps {
  title: string;
  circles: Circle[];
}

function PurposeMapSection({ title, circles }: PurposeMapSectionProps): JSX.Element {
  const [left, center, right] = circles;
  return (
    <div className={styles.section}>
      <div className={styles.title}>{title}</div>
      <div className={styles.circles}>
        <div id={left.id} className={`${styles.circle} ${classNames({ [styles.active]: left.isHighLighted })}`}>
          {left.value}
        </div>
        <div id={center.id} className={`${styles.circle} ${classNames({ [styles.active]: center.isHighLighted })}`}>
          {center.value}
        </div>
        <div id={right.id} className={`${styles.circle} ${classNames({ [styles.active]: right.isHighLighted })}`}>
          {right.value}
        </div>
      </div>
    </div>
  );
}

export default React.memo(PurposeMapSection);
